/**
 * Poster frame offset (seconds) for Mux `thumbnail-time` on all product-dashboard video embeds.
 * Kept in sync with the Analytics page overview player (see AnalyticsOverviewVideo).
 */
export const DASHBOARD_MUX_THUMBNAIL_TIME_SEC = 90
